import { AbstractContainer } from './AbstractContainer';
import { SetListenerIfc } from '../SetListenerIfc';
import { RecShapeIfc } from '../../shape/RecShapeIfc';
import { SetDispatcher } from './SetDispatcher';

export class AbstractSet extends AbstractContainer{
    protected dispatcher:SetDispatcher;
    recShape:RecShapeIfc;
    
    constructor( shape:RecShapeIfc ) 
    {
        super();
        this.recShape = shape;
        this.dispatcher = new SetDispatcher();
    }
    
    public destructImpl():void{
        throw new Error("Shouldn't be called");
    }
    
    public destruct():void{
        this.destructImpl();
        this.dispatcher.destruct();	
        
        this.recShape = null;
        this.dispatcher = null;
    }
    
    public getShape():RecShapeIfc {
        return this.recShape;
    }

    sendInitialLoad( listener:SetListenerIfc ):void{
        listener.begin();
        listener.reset();
        
        if( this.getSize() > 1){
            let records:Array<number> = new Array();
            let id:number = 0;
            for(let i:number = this.idMgr.nextSetBit(0);  i >= 0; i = this.idMgr.nextSetBit(i + 1)){
                records[id++] = i;
            }
            
            listener.addRecords( records ); 
        }else{
            if( this.getSize() == 1 ){
                listener.addRecord( this.idMgr.nextSetBit( 0 ) );	
            }
        }
        
        let metaSize:number = 0;
        let names:Array<string> = new Array();
        let values:Array<string> = new Array();
        this.metaData.forEach( (value:string, key:string, map:Map<string, string>) => {
            names[ metaSize ] = key;	
            values[ metaSize ] = value;
            metaSize++;
        });
        if ( metaSize > 0) {
            if ( metaSize > 1 )  {
                listener.setContainerMetaDatas( names, values );
            }else {
                listener.setContainerMetaData( names[ 0 ], values[ 0 ] );
            }
        }
        
        
        listener.end();
    }
    
    public addListener( listener:SetListenerIfc ):void {
        this.dispatcher.addListener(listener);
        this.sendInitialLoad(listener);
    }
    
    public removeListener( listener:SetListenerIfc ):void {
        this.dispatcher.removeListener(listener);
    }
}